import { Text, View } from '@components/primitives';
import ModalHeader from '@components/primitives/ModalHeader';
import colors from '@theme/colors';
import { verticalScale } from '@utils/normalize';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, TouchableOpacity } from 'react-native';

interface ModalInactiveWASProps {
  closeModalWDStatus?: () => void;
  showWDModal?: boolean;
  modalHeader?: string;
  imgStatusFile?: React.ReactNode;
  wdModalText?: string;
}

const ModalInactiveWAS: React.FC<ModalInactiveWASProps> = ({
  closeModalWDStatus = () => {},
  showWDModal = false,
  modalHeader = '',
  imgStatusFile = null,
  wdModalText = '',
}) => {
  const { t } = useTranslation('common');
  // Remove the ref and useEffect - control BottomSheet with index prop

  return (
    <Modal
      visible={showWDModal}
      animationType="none"
      presentationStyle="overFullScreen"
      transparent={true}
      onRequestClose={closeModalWDStatus}>
      <TouchableOpacity
        style={{
          flex: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          justifyContent: 'flex-end',
        }}
        activeOpacity={1}
        onPress={closeModalWDStatus}>
        <TouchableOpacity
          style={{
            backgroundColor: colors.neutral.cotton,
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            width: '100%',
            alignSelf: 'flex-end',
          }}
          activeOpacity={1}
          onPress={e => e.stopPropagation()}>
          <ModalHeader title={modalHeader ? t(modalHeader) : ''} onClose={closeModalWDStatus} />
          <View style={{ paddingHorizontal: 20, paddingVertical: 10 }}>
            <View alignContent="center" alignItems="center" marginX="5" marginY={verticalScale(8)}>
              <View alignItems="center" alignContent="center">
                {imgStatusFile}
              </View>
              <Text variant="md-normal">{wdModalText ? t(wdModalText) : ''}</Text>
            </View>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
};

export default ModalInactiveWAS;
